import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SolicitudDetallesGridComponent } from 'app/componentes/solicitud-detalles-grid/solicitud-detalles-grid.component';
import { AuxJasper, BuscaDetalleSolicitudInput, CatTipoGiros, FlujoTramitesInput, MonitoreoFlujoTramiteInput, ParametroJasper } from 'app/entidades/entidades';
import { AuthenticationService } from 'app/servicios';
import { FlujoTramitesInputService } from 'app/servicios/flujo-tramites.service';
import { MuestraMensaje } from 'app/shared/utilerias/notificaciones/notificaciones.component';
import { SelectItem } from 'primeng/api';


@Component({
  selector: 'app-seguimiento-contratos',
  templateUrl: './seguimiento-contratos.component.html',
  styleUrls: ['./seguimiento-contratos.component.css']
})
export class SeguimientoContratosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  usuario: any;
  datos: any;
  public IdSolicitud: number;
  public progressBar = false ;
  public EstadoTramite: string;
  public observacion: string;
  public fti: FlujoTramitesInput;
  public auxJasper: AuxJasper;
  public display: boolean = false;
  public displayIns: boolean = false;
  public buscaDetalleSolicitudInput$ = new EventEmitter<BuscaDetalleSolicitudInput>();
  public  MonitoreoFlujoTramiteInput$ = new EventEmitter<MonitoreoFlujoTramiteInput>();
  public reportesInspeccion: SelectItem[];
  reportesInspeccionSelected: null;
  MonitoreoFlujoTramiteInput:MonitoreoFlujoTramiteInput;


  @ViewChild(SolicitudDetallesGridComponent , {static: false }) childSolicitudDetallesGrid;

  constructor(
    private authenticationService:AuthenticationService,
    private router: Router,
    private flujoTramitesInputService: FlujoTramitesInputService,
  ) { }

  async ngOnInit() {
    try{
        await this.authenticationService.getUserByToken();
        this.fti  = new FlujoTramitesInput();
        await this.getAllCatInspeccion();

        this.usuario = this.authenticationService.currentUserValue;
        this.datos = history.state.example;
        console.log("this.datos2: ", this.datos);
        if(this.datos)
        {
          this.IdSolicitud = this.datos.idSolicitud;
          this.EstadoTramite = this.datos.estadoTramite;

          if (this.EstadoTramite === "CONTRATACIÓN" || this.EstadoTramite === "AJUSTES ADICIONALES") {
            //Emite Para Detalle del Trámit
            let buscaDetalleSolicitudInput = new BuscaDetalleSolicitudInput();
            buscaDetalleSolicitudInput.id = this.datos.idSolicitud;
            await this.buscaDetalleSolicitudInput$.emit(buscaDetalleSolicitudInput);
          }     
          
          this.fti.idSolicitudDetalle = this.datos.idSolicitudDetalle;
          this.fti.inicio = false;
          this.fti.idUsuario = this.usuario.id;
          this.fti.idEstatus = null;
          this.fti.idEtapaTramite = null;


          this.MonitoreoFlujoTramiteInput=null;
          this.MonitoreoFlujoTramiteInput = new MonitoreoFlujoTramiteInput();
          this.MonitoreoFlujoTramiteInput.idSolicitud= this.datos.idSolicitudDetalle;
          this.MonitoreoFlujoTramiteInput$.emit(this.MonitoreoFlujoTramiteInput);

        }else{
          this.EstadoTramite = 'Sin Ruta';
          this.router.navigateByUrl("atencion/informacion");
          this.muestraMensaje.notification(
            "No existe una solicitud Previa",
            "top",
            "center"
          );
        }

    } catch {
      this.muestraMensaje.notification(
        "No existe una solicitud Previa",
        "top",
        "center"
      );
    }
    
  }
  async Guardar(regresa: boolean){
    try{
      this.progressBar = true;
      if (this.observacion === undefined || this.observacion.length === 0) {
        throw new Error("La observación no debe estar vacía."); 
      }
      //Guardar las modificacion del detalle de la solicitud
      if((this.EstadoTramite == "CONTRATACIÓN" || this.EstadoTramite === "AJUSTES ADICIONALES") && regresa == false ){
        this.childSolicitudDetallesGrid.editaDetalleSolicitud(this.IdSolicitud);
        await this.imprimeSolicitud(this.IdSolicitud);
      }else{
        this.fti.observaciones =  this.observacion;
        this.fti.regresaFlujo = regresa;
        const datoRetorno = await this.flujoTramitesInputService
        .getBusquedas(this.fti)
        .toPromise();
        debugger;

        this.router.navigateByUrl("atencion/informacion");
        this.muestraMensaje.notification(
          "Guardar con éxito",
          "top",
          "center"
        );
      }
    }catch(e){
      debugger;

      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por Guardar")
      this.progressBar = false;
    }
  }
  async alCerrarVisor(){
    try{
      this.fti.observaciones =  this.observacion;
      this.fti.regresaFlujo = false;
      const datoRetorno = await this.flujoTramitesInputService
      .getBusquedas(this.fti)
      .toPromise();
      this.router.navigateByUrl("atencion/informacion");
      this.muestraMensaje.notification(
        "Guardar con éxito",
        "top",
        "center"
      );
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("alCerrarVisor")
    }
  }
  async imprimeSolicitud(_id_solicitud: number) {
    try{
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "Solicitud";
      this.auxJasper.JasperReport.tipo = "pdf";
      const parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_solicitud";
      parametroJasper.valor = _id_solicitud.toString() + "";
  
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      await this.showDialog();
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
        console.log('Paso por imprimeSolicitud');
    }
  };
  async imprimeInspeccion(selectedOption: any) {
    try{
      if(!selectedOption){this.muestraMensaje.error("Debe seleccionar un tipo de inspección.", "top", "center"); return;}

      this.auxJasper = new AuxJasper();
      const parametroJasper = new ParametroJasper();
      const parametroSoli = new ParametroJasper();
    
      //TODO - Ordenes de trabajo
      if(selectedOption === 1){
        this.auxJasper.JasperReport.nombreReporte = "014_Orden_Trabajo";
        this.auxJasper.JasperReport.tipo = "pdf";
        parametroJasper.nombre = "_tipo_inpeccion";
        parametroJasper.valor = "2";
        this.auxJasper.ParametroJasper.push(parametroJasper);
      }
      //TODO - Inspeccion catastro
      if(selectedOption === 2){
        this.auxJasper.JasperReport.nombreReporte = "015_Inspeccion_catastro";
        this.auxJasper.JasperReport.tipo = "pdf";
        parametroJasper.nombre = "_tipo_inpeccion";
        parametroJasper.valor = "1";
        this.auxJasper.ParametroJasper.push(parametroJasper);
      }
      parametroSoli.nombre = "_id_json_solicitud";
      parametroSoli.valor = this.IdSolicitud.toString();
      this.auxJasper.ParametroJasper.push(parametroSoli);
      this.displayIns = true;

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
        console.log('Paso por imprimeSolicitud');
    }
  };
  showDialog() {
    this.display = true;
  }
  async getAllCatInspeccion() {
    try {
      this.reportesInspeccion = [
        {label:"Orden de trabajo", value: 1},
        {label:"Inspección Catastro", value: 2}, 
      ];
      
    } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
    } finally {
        console.log('Paso por getAllCatInspeccion');
    }
}
}
